import { render, staticRenderFns } from "./Biometria.vue?vue&type=template&id=43a4d0ee"
import script from "./Biometria.vue?vue&type=script&lang=js"
export * from "./Biometria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports